import React, { useEffect, useState } from "react"
import { withRouter } from "react-router-dom"
import { isMobile } from "react-device-detect"
import unoptimizedPages from "./unoptimizedPages"
// Use require instead of import for browser-update
// import browserUpdate from "browser-update"
import { ToastContainer, toast } from "react-toastify"
import { OptimizationWarning, CompatibilityWarning } from "./warnings"

function BrowserCompatibilityWarning({
  history,
  checkUpdates,
  checkResponsiveness,
  testing = false,
  position = "top-right"
}) {
  var [isResponsive, setIsResponsive] = useState(testing)
  var [optimizationWarning, setOptimizationWarning] = useState("")
  var [compatibilityWarning, setCompatibilityWarning] = useState("")
  var [isOldBrowser, setIsOldBrowser] = useState(testing)

  useEffect(() => {
    if (isMobile && checkResponsiveness) {
      setIsResponsive(isPageResponsive(history.location))
      history.listen(location => {
        setIsResponsive(isPageResponsive(location))
      })
    }

    if (checkUpdates) {
      checkBrowserUpdate({
        test: testing, // This will be only in testing mode
        nomessage: true,
        onshow: function (infos) {
          setIsOldBrowser(true)
        }
      })
    }
  }, [])

  //Show message when a page is not responsive on mobile device
  useEffect(() => {
    if (optimizationWarning) {
      toast.dismiss(optimizationWarning)
    }
    if (isResponsive && isMobile) {
      var toastId = toast(<OptimizationWarning />, {
        autoClose: false,
        containerId: "browser-compatibility-warning",
        type: toast.TYPE.WARNING,
        className: "optimization-warning"
      })
      setOptimizationWarning(toastId)
    }
  }, [isResponsive])

  // Show message when browser is too old
  useEffect(() => {
    if (isOldBrowser) {
      if (!compatibilityWarning) {
      }
      var toastId = toast(<CompatibilityWarning />, {
        autoClose: false,
        containerId: "browser-compatibility-warning",
        type: toast.TYPE.WARNING,
        className: "compatibility-warning"
      })
      setCompatibilityWarning(toastId)
    } else {
      if (compatibilityWarning) {
        toast.dismiss(compatibilityWarning)
      }
    }
  }, [isOldBrowser])

  return (
    <React.Fragment>
      <ToastContainer
        className="browser--compatibility--warnings"
        position={position}
        autoClose={false}
        newestOnTop={false}
        closeOnClick={false}
        containerId={"browser-compatibility-warning"}
        rtl={false}
        pauseOnVisibilityChange
        draggable
      />
    </React.Fragment>
  )
}

export default withRouter(BrowserCompatibilityWarning)

export function checkBrowserUpdate(config = {}) {
  // Find more options on : http://browser-update.org/customize.html
  var defaultConfig = {
    required: { i: -2, f: -2, o: -2, s: -2, c: -2, e: -2 },
    api: 2020.05,
    insecure: true,
    unsupported: true,
    dont_show_debuginfo: true,
    nomessage: true
  }
  defaultConfig = {
    ...config,
    ...defaultConfig
  }
  // browserUpdate(defaultConfig)
}

export function isPageResponsive({ pathname }) {
  return unoptimizedPages.some(v => pathname.includes(v))
}
